// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import ReactDOM from 'react-dom/client';

import { render } from 'react-dom';
import Apollo from './framework/Apollo';

import '../sass/theme/main.scss';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';

import './script';

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(<Apollo />);
